(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_81edc1b"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[id^="DallmannWholesale-"]').forEach((root) => {

    const tabs = root.querySelectorAll('[data-dws-tab]');

    const cards = root.querySelectorAll('[data-dws-card]');

    const dynamicFilters = root.querySelectorAll('[data-dws-filter]');
    const mixedTierStatus = root.querySelector('[data-dws-mixed-tier-status]');

    const getTierPrice = (card, totalQuantity) => {
      if (!card || totalQuantity < 1) return null;
      const tierData = card.querySelector('[data-dws-tier-data]');
      if (!tierData) return null;
      try {
        const tiers = JSON.parse(tierData.textContent || '[]');
        let price = null;
        tiers.forEach((tier) => {
          if (totalQuantity >= Number(tier.minimum)) price = Number(tier.price);
        });
        return Number.isFinite(price) ? price : null;
      } catch (error) {
        return null;
      }
    };

    const updateMixedTierPreview = async () => {
      if (!mixedTierStatus || !window.fetch) return;
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        const groups = { bulk: 0, bars: 0 };
        (cart.items || []).forEach((item) => {
          const group = item.properties?.['_Wholesale tier group'];
          if (group === 'bulk' || group === 'bars') groups[group] += Number(item.quantity || 0);
        });
        const rows = [];
        ['bulk', 'bars'].forEach((group) => {
          if (!groups[group]) return;
          const cardsInGroup = Array.from(cards).filter((card) => card.dataset.dwsTierGroup === group);
          const prices = cardsInGroup.map((card) => getTierPrice(card, groups[group])).filter((price) => price !== null);
          if (!prices.length) return;
          const highestApplicable = Math.min(...prices);
          rows.push(`<span><strong>${group === 'bulk' ? 'Bulk Truffles' : 'Bars'}:</strong> ${groups[group]} combined units — tier preview from $${highestApplicable.toFixed(2)} each</span>`);
        });
        mixedTierStatus.innerHTML = rows.length ? `<div class="dws-mixed-tier-status__row">${rows.join('')}</div>` : '';
        mixedTierStatus.classList.toggle('is-visible', rows.length > 0);
      } catch (error) {
        // Preview is optional; do not interrupt wholesale ordering.
      }
    };



    const applyFilters = () => {

      const activeCategory = root.querySelector('.dws__tab.is-active')?.dataset.dwsTab;

      const veganOn = root.querySelector('[data-dws-filter="vegan"]')?.checked;

      const nonVeganOn = root.querySelector('[data-dws-filter="non-vegan"]')?.checked;

      const readyOn = root.querySelector('[data-dws-filter="ready"]')?.checked;

      cards.forEach((card) => {

        if (card.dataset.category !== activeCategory) {

          card.hidden = true;

          return;

        }

        const vegan = card.dataset.dwsVegan === 'true';

        const ready = card.dataset.dwsReady === 'true';

        let visible = true;

        if (veganOn) visible = visible && vegan;

        if (nonVeganOn) visible = visible && !vegan;

        if (readyOn) visible = visible && ready;

        card.hidden = !visible;

      });

    };



    tabs.forEach((tab) => tab.addEventListener('click', () => {

      tabs.forEach((item) => {

        const active = item === tab;

        item.classList.toggle('is-active', active);

        item.setAttribute('aria-selected', active ? 'true' : 'false');

      });

      applyFilters();

    }));

    dynamicFilters.forEach((input) => input.addEventListener('change', applyFilters));



    root.querySelectorAll('.dws-card__form').forEach((form) => {

      const stampFeeVariantId = Number(form.dataset.stampFeeVariant || 0);

      const quantitySelect = form.querySelector('[data-dws-quantity-select]');

      const card = form.closest('[data-dws-card]');

      const increment = Number(card?.dataset.dwsIncrement || 1);

      const minimum = Number(card?.dataset.dwsMoq || 1);



      if (quantitySelect) {

        quantitySelect.addEventListener('change', () => {

          const value = Number(quantitySelect.value);

          quantitySelect.setCustomValidity(value >= minimum && (value - minimum) % increment === 0 ? '' : `Please use a quantity starting at ${minimum} in increments of ${increment}.`);

        });

        form.addEventListener('submit', (event) => {

          const value = Number(quantitySelect.value);

          if (value >= minimum && (value - minimum) % increment === 0) return;

          event.preventDefault();

          quantitySelect.setCustomValidity(`Please use a quantity starting at ${minimum} in increments of ${increment}.`);

          quantitySelect.reportValidity();

        });

      }



      const amenitySleeveToggle = form.querySelector('[data-dws-amenity-sleeve]');

      const amenitySleeveFields = form.querySelector('[data-dws-amenity-sleeve-fields]');

      const amenityArtwork = form.querySelector('[data-dws-amenity-artwork]');

      if (amenitySleeveToggle && amenitySleeveFields && amenityArtwork) {

        const updateAmenitySleeve = () => {

          amenitySleeveFields.hidden = !amenitySleeveToggle.checked;

          amenityArtwork.required = amenitySleeveToggle.checked;

        };

        amenitySleeveToggle.addEventListener('change', updateAmenitySleeve);

        updateAmenitySleeve();

      }



      const selector = form.querySelector('select[name="id"]');

      const customization = form.querySelector('[data-dws-customization]');

      if (!selector || !customization) return;



      const artwork = form.querySelector('[data-dws-artwork]');

      const existingStamp = form.querySelector('[data-dws-existing-stamp]');

      const stampReference = form.querySelector('[data-dws-stamp-reference]');

      const feeNote = form.querySelector('[data-dws-fee-note]');

      const submitButton = form.querySelector('[type="submit"]');



      const updateCustomization = () => {

        const selected = selector.options[selector.selectedIndex];

        const needsNewStamp = selected?.dataset.newStamp === 'true';

        const usesExistingStamp = selected?.dataset.existingStamp === 'true';

        const usesCustomSleeve = selected?.dataset.customSleeve === 'true';

        const needsArtwork = needsNewStamp || usesCustomSleeve;

        customization.hidden = !(needsArtwork || usesExistingStamp);

        if (artwork) artwork.required = needsArtwork;

        if (existingStamp) existingStamp.hidden = !usesExistingStamp;

        if (stampReference) stampReference.required = usesExistingStamp;

        if (feeNote) feeNote.hidden = !needsNewStamp;

      };



      selector.addEventListener('change', updateCustomization);

      updateCustomization();



      form.addEventListener('submit', async (event) => {

        const selected = selector.options[selector.selectedIndex];

        if (selected?.dataset.newStamp !== 'true' || !stampFeeVariantId) return;

        event.preventDefault();

        submitButton.disabled = true;

        const originalText = submitButton.textContent;

        submitButton.textContent = 'Adding customization…';

        try {

          const rootPath = window.Shopify?.routes?.root || '/';

          const cartResponse = await fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } });

          if (!cartResponse.ok) throw new Error('Unable to check the cart.');

          const cart = await cartResponse.json();

          const feeIsPresent = cart.items.some((item) => item.variant_id === stampFeeVariantId);

          if (!feeIsPresent) {

            const feeResponse = await fetch(rootPath + 'cart/add.js', {

              method: 'POST',

              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

              body: JSON.stringify({ items: [{ id: stampFeeVariantId, quantity: 1, properties: { 'Fee type': 'New custom chocolate stamp design' } }] })

            });

            if (!feeResponse.ok) throw new Error('Unable to add the stamp setup fee.');

          }

          HTMLFormElement.prototype.submit.call(form);

        } catch (error) {

          if (feeNote) { feeNote.hidden = false; feeNote.textContent = error.message + ' Please try again.'; }

          submitButton.disabled = false;

          submitButton.textContent = originalText;

        }

      });

    });



    applyFilters();
    updateMixedTierPreview();
    document.addEventListener('cart:updated', updateMixedTierPreview);
    document.addEventListener('ajaxProduct:added', updateMixedTierPreview);
    window.addEventListener('pageshow', updateMixedTierPreview);

  });
  } catch(e) { console.error(e); }
})();

})();
